import { useEffect, useState } from 'react'

import {
  EVENT_NAME_MOUSE_DOWN,
  EVENT_NAME_MOUSE_MOVE,
  EVENT_NAME_MOUSE_UP,
} from '../../../../constants/event'
import { preventDefault } from '../../../../utils/events'

import { checkIsPanStartAllowed } from './usePdfViewerPan.utils'

export function usePdfViewerPan({ containerRef }) {
  const [isPanMode, setPanMode] = useState(false)
  const [isPanning, setPanning] = useState(false)

  useEffect(() => {
    const container = containerRef.current

    if (container) {
      const abortController = new AbortController()
      const { signal } = abortController

      function handleMouseDown(event) {
        if (checkIsPanStartAllowed({ event, isPanMode })) {
          preventDefault(event)
          setPanning(true)

          const startX = event.clientX
          const startY = event.clientY
          const startScrollLeft = container.scrollLeft
          const startScrollTop = container.scrollTop

          function handleMouseMove(moveEvent) {
            container.scrollLeft =
              startScrollLeft - (moveEvent.clientX - startX)
            container.scrollTop = startScrollTop - (moveEvent.clientY - startY)
          }

          function handleMouseUp() {
            setPanning(false)

            document.removeEventListener(EVENT_NAME_MOUSE_MOVE, handleMouseMove)
            document.removeEventListener(EVENT_NAME_MOUSE_UP, handleMouseUp)
          }

          document.addEventListener(EVENT_NAME_MOUSE_MOVE, handleMouseMove, {
            signal,
          })
          document.addEventListener(EVENT_NAME_MOUSE_UP, handleMouseUp, {
            signal,
          })
        }
      }

      container.addEventListener(EVENT_NAME_MOUSE_DOWN, handleMouseDown, {
        signal,
      })

      return () => {
        abortController.abort()
      }
    }
  }, [isPanMode])

  function handleTogglePanMode() {
    setPanMode(previousValue => !previousValue)
  }

  return {
    isPanMode,
    isPanning,
    onTogglePanMode: handleTogglePanMode,
  }
}
